import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LangContext";
import { useSite } from "@/context/SiteContext";
import { useAuth } from "@/context/AuthContext";
import { AppSocial } from "@/components/AppSocial";

export const Footer = () => {
  const { t } = useLang();
  const { on } = useSite();
  const { user } = useAuth();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#D4AF37]/15 bg-[#070B14] pb-32 pt-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <p className="font-display text-[18vw] font-semibold leading-[0.85] tracking-tight text-[#F4EEE2]/[0.06] md:text-[12vw]" aria-hidden>
          Awa In Kelet
        </p>
        <div className="mt-10 grid gap-10 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#B7BFCC]">{t("hero.tagline")}</p>
          </div>
          <div className="flex flex-col gap-3 font-ui text-sm">
            {[["/about", "nav.about", "about"], ["/sermons", "nav.sermons", "sermons"], ["/pastors", "nav.pastors", "pastors"], ["/events", "nav.gallery", "gallery"], ["/donate", "nav.donate", "donate"], ["/contact", "nav.contact", "contact"]].filter(([, , key]) => on(key)).map(([to, k]) => (
              <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`} className="w-fit text-[#F4EEE2]/80 transition-colors hover:text-[#D4AF37]">
                {t(k)}
              </Link>
            ))}
          </div>
          <div className="font-ui text-sm">
            <a href="mailto:support@awainkelet.org" data-testid="footer-email-link" className="flex items-center gap-2 text-[#F4EEE2] transition-colors hover:text-[#D4AF37]">
              <Mail className="h-4 w-4 text-[#D4AF37]" /> support@awainkelet.org
            </a>
            <p className="mt-3 text-[#B7BFCC]">{t("contact.addressValue")}</p>
          </div>
        </div>
        {on("footer_apps") && <AppSocial />}
        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-[#F4EEE2]/10 pt-6 font-ui text-xs text-[#9AA4B4] sm:flex-row">
          {on("footer_copyright") ? <p data-testid="footer-copyright">© {year} Awa In Kelet Radio. {t("footer.rights")}</p> : <span />}
          <span className="flex gap-5">
            {on("footer_privacy") && <Link to="/p/privacy-policy" data-testid="footer-privacy-link" className="hover:text-[#D4AF37]">{t("footer.privacy")}</Link>}
            {on("footer_terms") && <Link to="/p/terms-of-giving" data-testid="footer-terms-link" className="hover:text-[#D4AF37]">{t("footer.terms")}</Link>}
          </span>
          {user && <Link to="/admin" data-testid="footer-portal-link" className="hover:text-[#D4AF37]">{t("footer.portal")}</Link>}
        </div>
      </div>
    </footer>
  );
};
